/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/**
 * Created by jakebillings on 7/31/16.
 */
/*global angular*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

const API_BASE = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class TeamReportDiscountService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`${API_BASE}teamReportDiscounts`, {
      withCredentials: true,
    });
  }

  remove(teamReportDiscountId: string): Observable<any> {
    return this.http.delete(
      `${API_BASE}teamReportDiscounts/${teamReportDiscountId}`,
      {
        withCredentials: true,
      }
    );
  }

  save(teamReportDiscount: any): Observable<any> {
    return this.http.post(
      `${API_BASE}teamReportDiscounts`,
      teamReportDiscount,
      {
        withCredentials: true,
      }
    );
  }

  getById(teamReportDiscountId: string): Observable<any> {
    return this.http.get<any>(
      `${API_BASE}teamReportDiscounts/${teamReportDiscountId}`,
      {
        withCredentials: true,
      }
    );
  }

  getByName(teamReportDiscountName: string): Observable<any> {
    return this.http.get<any>(
      `${API_BASE}teamReportDiscounts/byName/${teamReportDiscountName}`,
      {
        withCredentials: true,
      }
    );
  }
}
